export const businessTools = [
  {
    id: "convocore",
    name: "Convocore",
    label: "Recommended Business Tool",
    category: "Digital Agent Platform",
    logoUrl: "/convocore-logo.svg",
    headline: "Launch a digital agent for your business without wasting weeks figuring out the setup.",
    shortDescription:
      "Convocore helps businesses create digital agents for customer questions, lead qualification, sales support, onboarding, and internal workflows.",
    description:
      "You can use Convocore directly and build your own agent, or you can let FIKAMI configure it around your real business process. We help define the right use case, structure the conversation flow, connect it to your workflow, and make sure it becomes a useful business tool — not just another platform you pay for and never use.",
    useCases: [
      "Customer support",
      "Lead qualification",
      "Sales follow-up",
      "Internal workflows",
    ],
    directCta: "Try Convocore directly",
    directUrl: "https://convocore.ai/?aff=miguelangel",
    serviceCta: "Configure Convocore with FIKAMI",
    serviceUrl: "#contact",
    disclosure:
      "FIKAMI may receive referral compensation if you use our Convocore link.",
  },
];
